import { ExternalLink } from 'react-feather';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { GetMessageQuery as GetMessage } from '__generated__/graphql';

import ContactPicker, { Participant } from '../../Participants/Contacts/ContactPicker';
import UI from '../../../common/UI';

type Message = GetMessage['project']['message'];

export interface PreviewMessageFormProps {
  message: Message;
}

const PreviewMessageForm = ({ message }: PreviewMessageFormProps) => {
  const { t } = useTranslation();

  const [participant, setParticipant] = useState<Participant>();

  return (
    <>
      <UI.Div sc={{ mb: 4 }}>
        <UI.SectionHeading sc={{ mb: 0 }}>
          {t('preview_message')}
        </UI.SectionHeading>
        <UI.InputDescription>
          {t('preview_message_description')}
        </UI.InputDescription>
      </UI.Div>
      <UI.Card sc={{ hasPanels: true }}>
        <UI.FormGrid>
          {message.draft && (
            <UI.Warning>
              {t('message_draft_warning')}
            </UI.Warning>
          )}
          <UI.InputGroup>
            <UI.InputLabel>
              {t('preview')}
            </UI.InputLabel>
            <UI.FormGrid sc={{ columns: '1fr fit-content(200px)', gutter: 0.5 }}>
              <UI.Div>
                <ContactPicker
                  participant={participant}
                  onChange={(participant) => setParticipant(participant)}
                  filters={{ event: message.event.id }}
                  disabled={message.draft}
                  nullable={false}
                />
              </UI.Div>
              <UI.AButton
                href={`/b/api/messages/${message.id}/preview/${participant?.id}`}
                target="_blank"
                rel="noopener noreferer"
                sc={{ disabled: !participant }}
              >
                {t('view_in_browser')}
                <UI.Icon sc={{ ml: 1 }}>
                  <ExternalLink />
                </UI.Icon>
              </UI.AButton>
            </UI.FormGrid>
          </UI.InputGroup>
        </UI.FormGrid>
      </UI.Card>
    </>
  );
};

export default PreviewMessageForm;
